import { Switch, Route, Redirect, useRouteMatch, useParams } from 'peach/router'

import PersonContactRoutes from './contacts/PersonContactRoutes'
import DocumentRoutes from './documents/DocumentRoutes'
import PaymentInstrumentRoutes from './PaymentInstruments/PaymentInstrumentRoutes'
import PersonCasesRoutes from './PersonCases/PersonCasesRoutes'
import PersonConsents from './PersonConsents'
import PersonLoans from './PersonLoans'
import PersonRecord from './PersonRecord'
import PersonInteractionRoutes from './Interactions/PersonInteractionRoutes'

const PersonRoutes = () => {
  const { path, url } = useRouteMatch()
  const { personId } = useParams()

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <PersonRecord />
      </Route>

      <Route crumb exact path={`${path}/loans`}>
        <PersonLoans personId={personId} />
      </Route>

      <Route crumb path={`${path}/consents`}>
        <PersonConsents />
      </Route>

      <Route crumb path={`${path}/contacts`}>
        <PersonContactRoutes />
      </Route>

      <Route crumb path={`${path}/payment-instruments`}>
        <PaymentInstrumentRoutes />
      </Route>

      <Route crumb path={`${path}/cases`}>
        <PersonCasesRoutes />
      </Route>

      <Route crumb path={`${path}/documents`}>
        <DocumentRoutes />
      </Route>

      <Route crumb path={`${path}/interactions`}>
        <PersonInteractionRoutes />
      </Route>

      <Redirect to={`${url}`} />
    </Switch>
  )
}

export default PersonRoutes
